import { styled } from "../../styles";

export const Radio = styled("label", {
  content: "",
  height: "13px",
  width: "13px",

  "input[type=radio]": {
    accentColor: "var(--colors-portal-radio-button-dot)",
  },

  input: {
    "&:hover": {
      cursor: "pointer",
    },
  },
});
